import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingChat from './components/FloatingChat';
import AnnouncementBanner from './components/AnnouncementBanner';
import PerformanceMonitor from './components/PerformanceMonitor';
import Home from './pages/Home';
import About from './pages/About';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Announcements from './pages/Announcements';
import Downloads from './pages/Downloads';
import FAQs from './pages/FAQs';

// Service Worker Registration
const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then((registration) => {
          console.log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
};

function App() {
  useEffect(() => {
    // Register service worker for PWA functionality
    registerServiceWorker();
    
    // Initialize AOS globally with optimized settings
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 50,
      delay: 0,
      anchorPlacement: 'top-bottom',
    });
  }, []);

  return (
    <Router>
      <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
        <PerformanceMonitor />
        <Helmet>
          <title>Rasoha Academy | Excellence in Education</title>
          <meta name="description" content="Official website for Rasoha Academy Narok. Explore events, gallery, announcements, and more. Quality education in Kenya." />
          <meta name="keywords" content="Rasoha Academy, Narok, School, Education, Kenya, Private School, Academic Excellence" />
          <meta name="robots" content="index, follow" />
          <meta name="author" content="Rasoha Academy" />
          <meta property="og:title" content="Rasoha Academy | Excellence in Education" />
          <meta property="og:description" content="Official website for Rasoha Academy Narok. Quality education in Kenya." />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://rasohaacademy.com" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Rasoha Academy | Excellence in Education" />
          <meta name="twitter:description" content="Official website for Rasoha Academy Narok. Quality education in Kenya." />
        </Helmet>
        <AnnouncementBanner />
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/events" element={<Events />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/downloads" element={<Downloads />} />
            <Route path="/faqs" element={<FAQs />} />
          </Routes>
        </main>
        <Footer />
        <FloatingChat />
      </div>
    </Router>
  );
}

export default App; 